import { GoogleIcon } from '@app/assets';
import { typedEnv } from '@app/environment/typed-env';
import { useCurrentLanguage } from '@app/i18n/useCurrentLanguage';
import { AUTH_QUERY_PARAM_AUTO_LINK_QR_ID } from '@app/modules/auth/auth.constants';
import { SignUpInDto } from '@app/swagger-types';
import { checkTypeCompliance } from '@app/utils/type.utils';
import { useTranslation } from 'react-i18next';
import { Button } from '../button/Button';

const KEY_LANGUAGE = 'language';

checkTypeCompliance<keyof SignUpInDto, typeof KEY_LANGUAGE>();
checkTypeCompliance<keyof SignUpInDto, typeof AUTH_QUERY_PARAM_AUTO_LINK_QR_ID>();

export const GoogleButton: React.FC<{
  autoLinkQRID?: string | null;
  onPreClick?: () => void;
}> = ({ autoLinkQRID, onPreClick }) => {
  const { t } = useTranslation();
  const language = useCurrentLanguage();

  return (
    <Button
      onClick={() => {
        onPreClick?.();
        // TODO use env for api host
        const url = new URL(typedEnv.REACT_APP_OAUTH_GOOGLE_URL);
        if (language) {
          url.searchParams.set(KEY_LANGUAGE, language);
        }
        if (autoLinkQRID) {
          url.searchParams.set(AUTH_QUERY_PARAM_AUTO_LINK_QR_ID, autoLinkQRID);
        }
        window.location.href = url.toString();
      }}
      variant="outlined"
      className="w-full"
    >
      <GoogleIcon className="mr-2" />
      {t('auth.continueWithGoogle')}
    </Button>
  );
};
